
// import { supabase } from '@/integrations/supabase/client';
const DATA_URL = import.meta.env.VITE_DATA_URL;

/**
 * Fetches dashboard data from Supabase storage with fallback handling
 */
export async function fetchDataWithFallback(fileName: string, fallback: any = {}) {
  try {
    // SAST FIX: sanitize fileName to prevent path traversal
    // Allow only alphanumeric characters, dashes, underscores, and dots. 
    // Explicitly reject ".." or "/"
    if (!/^[a-zA-Z0-9.\-_]+$/.test(fileName) || fileName.includes('..') || fileName.includes('/')) {
      console.error(`Invalid filename rejected: ${fileName}`);
      return fallback;
    }

    // const response = await supabase.storage.from('dane').download(fileName);
    // Fetch from VPS
    const response = await fetch(`${DATA_URL}/${fileName}`);

    if (!response.ok) {
      console.warn(`Failed to load ${fileName}:`, response.statusText);

      // Fallback to local mock data if available
      try {
        const localResponse = await fetch(`/mock-data/${fileName}`);
        if (localResponse.ok) {
          console.info(`Loaded local mock data for ${fileName}`);
          return await localResponse.json();
        }
      } catch (localError: any) {
        console.warn(`Failed to load local mock data for ${fileName}:`, localError);
      }

      return fallback;
    }

    const parsedData = await response.json();
    return parsedData;

    /*
    const text = await response.data.text();

    try {
    } catch (parseError) {
      console.error(`Error parsing JSON from ${fileName}:`, parseError);
      return fallback;
    }
    */
  } catch (error) {
    console.warn(`Error processing ${fileName}:`, error);
    return fallback;
  }
}

/**
 * Fetches all data sources needed for the dashboard
 */
export async function fetchAllDashboardData(newsFileName: string = 'newsen.json') {

  // Return a promise that fetches all data in parallel
  return Promise.all([
    fetchDataWithFallback('leak.json', []),
    fetchDataWithFallback('ransomware.json', []),
    fetchDataWithFallback('2025.json', []),
    // Fetch both news files
    Promise.all([
      fetchDataWithFallback('newsen.json', { items: [] }),
      fetchDataWithFallback('newspl.json', { items: [] })
    ]),
    fetchDataWithFallback('eol.json', {}),
    fetchDataWithFallback('releases.json', []),
  ]);
}
